// @flow
import { type Store, guard } from 'effector'
import type { PhonesStore } from '../types'
import { fetchRequest, fetchPhones } from './events'
import { PhoneDomain } from './domain'

const $phones: Store<null | PhonesStore> = PhoneDomain.store(null)

$phones.on(fetchRequest.done, (state, { result }) => ({ ...state, ...result }))

guard({
  source: fetchPhones,
  filter: fetchRequest.pending.map((pending) => !pending),
  target: fetchRequest,
})

export { $phones }
